import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";

import SocialButtons from "./social-buttons"
import LoginLogo from "./login-logo"
import EmailButton from "./email-button"
import LOGIN_EMAIL_ACTIONS from "../../constants/LOGIN_EMAIL_ACTIONS";
import {getTranslation} from "../../helpers/get-translation";
import Divider from "@material-ui/core/Divider";


const styles = theme => ({
	root: {
		overflowX: 'hidden',
		overflowY: "auto",
		"-webkit-overflow-scrolling": "touch",
	},
	container: {
		width: "80%",
		paddingTop: "20px",
		margin: '1vh auto',
		"& button": {
			width: "100%",
			margin: "15px 0",
			"& div":{
				width: "100%",
			},
			"& span":{
				"@media screen and (max-width: 500px)": {
					fontSize: "13px"
				}
			},
			"& img":{
				height: "25px",
				width: "auto",
				float: "left"
			},
		}
	},
	divider:{
		margin: "15px 20px 25px"
	},
	termsText:{
		marginBottom: "25px",
		textAlign: "center",
		color: "gray",

		"& a, & a:visited":{
			color: "gray",
		}
	}
});

function LoginScreen(props){
	const { classes, push } = props;

	return (
		<div className={classes.root}>
			<div className={classes.container}>
				<LoginLogo/>
				<SocialButtons
					booleans={props.booleans}
					fsLoginUserSocial={props.fsLoginUserSocial}
				/>
				<EmailButton onClick={() => push(LOGIN_EMAIL_ACTIONS.LOGIN)}/>
				<Divider className={classes.divider}/>
				<div className={classes.termsText} dangerouslySetInnerHTML={{__html: getTranslation("login_terms")}}>
				</div>
			</div>
		</div>
	)
}

LoginScreen.propTypes = {
	booleans: PropTypes.object.isRequired,

	classes: PropTypes.shape({
		root: PropTypes.string.isRequired,
	}).isRequired,

	fsLoginUserSocial: PropTypes.func.isRequired,
};

export default withStyles(styles)(LoginScreen);